<template>
    <div>
        <div class="pagination-wrap">
            <div class="row">
                <div class="col">
                    <div class="row">
                    <div class="col">
                        <b-pagination
                            style="padding-bottom: 8px;"
                            align="left"
                            size="md"
                            :total-rows="availablePagination.total"
                            :per-page="availablePagination.perPage"
                            v-on:change="changeAvailablePage"
                            v-model="availablePagination.currentPage"></b-pagination>
                    </div>
                    <div class="col text-right">
                        <p class="inline-block">Rows per page</p>
                        <b-form-select
                            v-model="availablePagination.perPage"
                            v-on:input="() => changeAvailablePage(1)"
                            :options="[{text:5,value:5},{text:10,value:10},{text:15,value:15},{text:25,value:25},{text:50,value:50},{text:100,value:100}]"

                            class="rows-select" cols=1
                            ></b-form-select>
                    </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row" v-if="pagination">
                    <div class="col">
                        <b-pagination
                            style="padding-bottom: 8px;"
                            align="left"
                            size="md"
                            :total-rows="pagination.total"
                            :per-page="pagination.perPage"
                            v-on:change="(value) => changeSelectedPage({ page: value })"
                            v-model="pagination.currentPage"></b-pagination>
                    </div>
                    <div class="col text-right">
                        <p class="inline-block">Rows per page</p>
                        <b-form-select
                            v-model="pagination.perPage"
                            v-on:input="(value) => changeSelectedPage({ per_page: value })"
                            :options="[{text:5,value:5},{text:10,value:10},{text:15,value:15},{text:25,value:25},{text:50,value:50},{text:100,value:100}]"
                            class="rows-select" cols=1
                            ></b-form-select>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-deck multi-select">
            <div class="col p-0">
                <div class="card">
                    <div class="card-header d-flex flex-row align-items-end">
                        <!-- <div> -->
                            <ul v-if="!_.isEmpty(customFilters)" class="multi-select-filter list-unstyled mb-0">
                                <custom-filter-component
                                    v-for="filter in customFilters"
                                    :key="filter.name"
                                    :changeFilter="changeFilter"
                                    :config="filter" />
                            </ul>
                            <div v-else class="card-header-title"><b>Available</b></div>
                            <form v-if="_.has(config, 'searchable') && _.get(config, 'searchable')" v-on:submit="changeAvailableSearch"
                                :class="['card-header-search ml-auto', _.isEmpty(customFilters) ? 'mt-0' : '']">
                                <div class="input-group">
                                <input v-model="unselectedFilter"
                                    type="text"
                                    class="form-control search"
                                    placeholder="Search..."
                                    role="combobox" />
                                    <div class="input-group-append">
                                        <button type="submit" class="btn btn-navy px-2"><i class="material-icons md-18 mt-1">search</i></button>
                                    </div>
                                </div>
                            </form>
                        <!-- </div> -->
                    </div>
                    <div v-if="!loadingAvailable" class="list-group">
                        <div v-for="item in unselected" href="javascript:void(0)" target="_self" :key="item.id"
                            class="list-group-item list-group-item-action">
                            <img v-if="!noImage" :src="getImageLink(item)" />
                            <a v-if="item.link" :href="item.link" v-html="item.name" class="list-group-item-label"></a>
                            <span v-else class="list-group-item-label" v-html="item.name"></span>
                            <!-- <br/><i>{{item.description}}</i> -->
                            <button v-if="_.includes(unselectedProcessingIds, item.id)"
                                :class="['btn', 'btn-light', 'btn-rounded', 'btn-sm', 'btn-arrow']"
                                type="button" disabled>
                                <i class="material-icons">more_horiz</i>
                            </button>
                            <button v-else v-on:click="select(item)"
                                :class="['btn', 'btn-light', 'btn-rounded', 'btn-sm', 'btn-arrow']"
                                type="button">
                                <i class="material-icons">arrow_forward</i>
                            </button>
                        </div>
                    </div>
                    <div style="margin: 3rem auto" v-else>
                        <vue-spinner></vue-spinner>
                    </div>
                </div>
            </div>

            <div class="col p-0">
                <div class="card">
                    <div class="card-header d-flex flex-row align-items-end">
                        <!-- <div> -->
                            <div class="card-header-title"><b>Selected</b></div>
                            <form v-if="_.has(config, 'searchable') && _.get(config, 'searchable')" v-on:submit="changeSelectedSearch"
                                :class="['card-header-search ml-auto', 'mt-0']">
                                <div class="input-group">
                                <input v-model="selectedFilter"
                                    type="text"
                                    class="form-control search"
                                    placeholder="Search..."
                                    role="combobox" />
                                    <div class="input-group-append">
                                        <button type="submit" class="btn btn-navy px-2"><i class="material-icons md-18 mt-1">search</i></button>
                                    </div>
                                </div>
                            </form>
                        <!-- </div> -->
                    </div>
                    <draggable
                        v-if="updating || !loading"
                        v-model="selected"
                        v-on:end="changePriority"
                        :options="{ 'disabled': !priorityField }"
                        class="list-group">
                        <div v-for="item in filteredSelected" href="javascript:void(0)" target="_self" :key="item.id"
                            class="list-group-item list-group-item-action">
                            <i v-if="priorityField" class="material-icons drag-icon">view_headline</i>
                            <img v-if="!noImage" :src="getImageLink(item)" />
                            <a v-if="item.link" :href="item.link" v-html="item.name" class="list-group-item-label flex-shrink-1"></a>
                            <span v-else class="list-group-item-label" v-html="item.name"></span>
                            <!-- <br/><i>{{item.description}}</i> -->
                            <button v-if="_.includes(selectedProcessingIds, item.id)" type="button" disabled
                                :class="['btn', 'btn-light', 'btn-rounded', 'btn-sm', 'btn-arrow']">
                                <i class="material-icons">more_horiz</i>
                            </button>
                            <button v-else type="button" v-on:click="deselect(item)"
                                class="btn btn-light btn-rounded btn-sm btn-arrow">
                                <i class="material-icons">arrow_back</i></button>
                        </div>
                    </draggable>
                    <div style="margin: 3rem auto" v-else>
                        <vue-spinner></vue-spinner>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import V from 'voca';
import _ from 'lodash';
import { singular } from 'pluralize';
import Draggable from 'vuedraggable';

import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import CustomFilterComponent from './CustomFilterComponent';

export default {
    data() {
        const type = _.get(this.content, 'type');
        const selectedFilter = _.get(this.query, `search[${type}]`, null);

        return {
            selected: [],
            selectedProcessingIds: [],
            unselected: [],
            unselectedProcessingIds: [],
            available: [],
            selectedFilter,
            unselectedFilter: null,
            currentGroup: null,
            loadingAvailable: true,

            filter: {

            },

            sort: {

            },

            availablePagination: {
                perPage: 15,
                total: 1,
                currentPage: 1,
            },

            initialized: false,
            updating: false,
        }
    },

    props: [
        'content', 'contentType', 'parent', 'loading',
        'relationship', 'timestamp', 'query', 'section', 'config',
        'resourceParams', 'changeQuery', 'changeUrl',
        'updateBatch', 'createData', 'updateData', 'deleteData',
    ],

    components: {
        CustomFilterComponent,
        Draggable,
        VueSpinner: MoonLoader,
    },

    mounted() {
        const config = this.config;
        this.$emit('content::initialized', {
            type: this.content.type,
            name: 'multi-select-component',
            config,
        });

        const formatter = config.formatter || this.simpleFormat;
        this.selected = this.content.data.map(item => formatter(item));

        this.fetchAvailableData({
            filter: this.getFilterQuery(),
            sort: this.getSortQuery(),
        })
            .then(() => {
                this.initialized = true;
                this.$forceUpdate();
            })
    },

    watch: {
        timestamp() {
            const formatter = this.config.formatter || this.simpleFormat;
            const newData = this.content.data || [];
            const selectedIds = newData.map(item => item.id);
            const selected = newData.map(item => formatter(item))
                .sort((item1, item2) => item1[this.priorityField] > item2[this.priorityField] ? 1 : -1);
            const unselected = this.available.filter(item => selectedIds.indexOf(item.id) < 0);

            this.selected = selected;
            this.unselected = unselected;
        },
    },

    computed: {
        endpoint() {
            let endpoint = this.config.endpoint || `/${this.content.type}`;

            if (_.isFunction(endpoint)) {
                endpoint = endpoint(this);
            }

            return endpoint;
        },

        priorityField() {
            if (this.selectedFilter) return null;
            return _.get(this.content, 'data.[0].meta.priority_pivot');
        },

        customFilters() {
            return _.get(this.config, 'customFilters', []);
        },

        filteredSelected() {
            return this.selected
                .filter(item => {
                    let pass = true;
                    return pass;
                })
        },

        noImage() {
            return _.get(this.config, 'noImage')
        },

        type() {
            return _.get(this.content, 'type');
        },

        pagination() {
            const meta = _.get(this.content, 'meta', {});

            return {
                currentPage: _.get(meta, 'current_page', 1),
                perPage: _.chain(meta).get('per_page', 15).parseInt().value(),
                total: _.chain(meta).get('total', 0).parseInt().value(),
                from: _.chain(meta).get('from', 0).parseInt().value(),
                to: _.chain(meta).get('to', 0).parseInt().value(),
                last_page: _.chain(meta).get('last_page', 1).parseInt().value(),
                options: [
                    { text: 5, value: 5 },
                    { text: 10, value: 10 },
                    { text: 15, value: 15 },
                    { text: 25, value: 25 },
                    { text: 50, value: 50 },
                    { text: 100, value: 100 },
                ]
            }
        },
    },

    methods: {
        select(item) {
            this.updating = true;
            this.$emit('item-select', item);
            this.unselectedProcessingIds.push(item.id);
            this.updateBatch([
                { id: item.id, $attach: true },
            ], {
                updateParent: true
            }).then(() => {
                this.unselectedProcessingIds = _.reject(this.unselectedProcessingIds, (id) => id == item.id);
                this.updating = false;
                this.$forceUpdate();
            });
        },

        deselect(item) {
            this.updating = true;
            this.$emit('item-deselect', item);
            this.selectedProcessingIds.push(item.id);
            this.updateBatch([
                { id: item.id, $detach: true },
            ], {
                updateParent: true
            }).then(() => {
                this.selectedProcessingIds = _.reject(this.selectedProcessingIds, (id) => id == item.id);
                this.updating = false;
                this.$forceUpdate();
            });
        },

        changePriority(event) {
            const { oldIndex, newIndex } = event;
            if (oldIndex === newIndex) return;

            const [lesserIndex, greaterIndex] = oldIndex < newIndex ? [oldIndex, newIndex] : [newIndex, oldIndex];

            const changedItems = this.selected.slice(lesserIndex, greaterIndex + 1);
            const changedItemIds = changedItems.map(item => item.id);

            const orderedPriorities = changedItems.map(item => item[this.priorityField]).slice().sort((value1, value2) => {
                if (parseInt(value1) > parseInt(value2)) return 1;
                return -1;
            });

            const updatedData = _.zip(changedItemIds, orderedPriorities)
                .map(([id, priority]) => ({ id, $update:{ [this.priorityField]: priority } }))

            this.updating = true;
            this.updateBatch(updatedData, {
                setNotification: true,
            }).then(() => {
                this.updating = false;
            });
        },

        changeSelectedPage(query) {
            this.changeQuery(_.assign({
                search: this.selectedFilter,
                page: this.pagination.currentPage,
                per_page: this.pagination.perPage,
            }, query));
        },

        changeAvailablePage(value) {
            console.log(value);
            this.fetchAvailableData({
                filter: this.getFilterQuery(),
                sort: this.getSortQuery(),
                page: value,
                search: this.unselectedFilter,
                per_page: this.availablePagination.perPage,
            });
        },

        simpleFormat(value) {
            const { id, type, attributes, meta } = value;
            return {
                ...(meta || {}),
                ...(attributes || {}),
                id, type,
            };
        },

        changeSelectedSearch(e) {
            e.preventDefault();

            this.changeQuery({
                [`search[${this.type}]`]: this.selectedFilter,
                page: this.pagination.currentPage,
                per_page: this.pagination.perPage,
            });
        },

        changeAvailableSearch(e) {
            e.preventDefault();

            this.fetchAvailableData({
                filter: this.getFilterQuery(),
                sort: this.getSortQuery(),
                search: this.unselectedFilter,
                page: this.availablePagination.currentPage,
                per_page: this.availablePagination.perPage,
            });
        },

        changeFilter(key, value) {
            this.filter[key] = value;

            this.fetchAvailableData({
                filter: this.getFilterQuery(),
                sort: this.getSortQuery(),
                search: this.unselectedFilter,
                per_page: this.availablePagination.perPage,
                page: 1,
            });
        },

        getFilterQuery() {
            let defaultFilter = _.get(this.config, 'filter', {});

            if (_.isFunction(defaultFilter)) {
                defaultFilter = defaultFilter(this.$route);
            }

            return _.chain(this.filter)
                .merge(defaultFilter)
                .toPairs()
                .filter(([key, value]) => !!value)
                .map(([key, value]) => `${key}:${value}`)
                .join(';')
                .value();
        },

        getSortQuery() {
            const defaultSort = _.get(this.config, 'sort', {});

            return _.chain(this.sort)
                .merge(defaultSort)
                .toPairs()
                .filter(([key, value]) => !!value)
                .map(([key, value]) => `${key}:${value}`)
                .join(';')
                .value();
        },

        fetchSelectedData() {
            const formatter = this.config.formatter || this.simpleFormat;
            return this.changeQuery({

            })
        },

        fetchAvailableData(query = {}) {
            let available = [];
            let unselected = [];

            const formatter = this.config.formatter || this.simpleFormat;
            this.loadingAvailable = true;
            return this.helpers('api').getData(this.endpoint, query)
                .then(response => {
                    const { data, meta } = response;
                    const selectedIds = (this.content.data || []).map(item => item.id);

                    available = _.map(data, item => formatter(item));
                    unselected = _.filter(available, item => selectedIds.indexOf(item.id) < 0);
                    this.available = available;
                    this.unselected = unselected;
                    this.loadingAvailable = false;

                    this.availablePagination = {
                        currentPage: meta.current_page,
                        perPage: parseInt(meta.per_page),
                        total: parseInt(meta.total),
                        from: parseInt(meta.from),
                        to: parseInt(meta.to),
                    }
                })
        },

        getImageLink(item) {
            return _.get(item, 'image_link') || _.imgPath(_.get(item, 'image', null), 'w50_h50');
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/LazyloadingMultiSelectComponent.vue